"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentMethodMock = exports.visibilityMock = exports.portOfDischargeStopMock = exports.portOfLoadingStopMock = exports.deliveryStopMock = exports.additionalStopMock = exports.pickupStopMock = exports.airCarrier = exports.marineCarrier = exports.marineCarrierOld = exports.railCarrier = exports.roadCarrier = exports.carrierMock = exports.shipmentContactMock = exports.assuredMock = exports.contactMock = exports.businessMock = exports.cargoClassInstanceMock = exports.cargoMock = exports.cargoFromV1Mock = exports.temperatureRangeMock = exports.userV2Mock = exports.userV1Mock = exports.internationalProduct = exports.certificateV1insuranceProductMock = exports.insuranceProductMock = exports.insuranceCoverageMockWithAddressAndLicenses = exports.insuranceCoverageMockWithAddressCountryStateAndLicensesBreakdowns = exports.insuranceCoverageMockWithAddressCountryStateAndLicensesNoLicenseExp = exports.insuranceCoverageMockWithAddressCountryStateAndLicenses = exports.insuranceCoverageMockNoAddressLicenses = exports.taxBreakdownMock = exports.serviceFeeBreakdownMock = exports.insuranceCoverageCommissionMock = exports.insuranceCoverageCostsMock = exports.insuranceCoverageCostsV1Mock = exports.insuranceCoverageCostsBaseMock = exports.insuranceCoverageDescriptionMock = exports.restrictionsMock = exports.exFreightPartnerMock = exports.partnerWithAddressMock = exports.partnerNoAddressWithLicenseTaxesMock = exports.partnerNoAddressMock = exports.insuranceLicenseMock = exports.addressMock = exports.addressCountryStateMock = exports.emptyAddressMock = exports.binderMockV1 = exports.getProductBinderMock = exports.participartingInsurers = void 0;
exports.invoiceAdjustmentPendingMock = exports.newInvoiceAdjustmentMock = exports.existingInvoiceAdjustmentMock = exports.getInvoiceMock = exports.getMasterPolicyMock = exports.participatingInsurersEndorsementMock = exports.partnerAddressChangeEndorsementMock = exports.partnerNameEndorsementMock = exports.licenseChangeEndorsementMock = exports.licenseChangeOldEndorsementMock = exports.AnnualCargoCommodityMock = exports.claimInternationalMock = exports.claimDomesticMock = exports.warehouseMock = exports.locationMock = exports.lossesMock = exports.exposuresMock = exports.mockDocument = exports.policyData = exports.mockBroker = exports.partnerBillingMock = exports.partnerInfoMock = exports.emptyPartnerInfoMock = exports.blobAttachmentFile = exports.pathAttachmentFile = exports.certificateChangeHistoryMock = exports.certificateChangeDetailsEmptyMock = exports.certificateCancelChangeEmptyMock = exports.certificateCancelChangeMock = exports.certificateCurrentFromV2to4Mock = exports.certificateCurrentFromV1 = exports.certificateCurrentMock = exports.certificateV5Mock = exports.certificateV4Mock = exports.certificateV3Mock = exports.certificateV2Mock = exports.certificateV1Mock = exports.InsuranceCertificatePurchaseRequestMock = exports.insurancePurchaseV1Mock = exports.InsuranceCertificatePurchaseResponseMock = exports.insuranceLoadV1Mock = exports.shipmentV2Mock = exports.shipmentV2FromV1Mock = exports.shipmentV1Mock = exports.CCPaymentMock = exports.paymentMock = void 0;
const utils_1 = require("@loadsure/utils");
const _1 = require(".");
const international_1 = require("./international");
const invoiceAdjustment_1 = require("./invoice/invoiceAdjustment");
const certificateChange_1 = require("./certificateChange");
const cargo_1 = require("./cargo");
const currencies_1 = require("./currencies");
const partner_1 = require("./partner");
const payments_1 = require("./payments");
const policy_1 = require("./policy/policy");
const address_1 = __importDefault(require("./address"));
const assured_1 = __importDefault(require("./assured"));
const broker_1 = __importDefault(require("./policy/broker"));
const contact_1 = __importDefault(require("./contact"));
const user_1 = __importDefault(require("./user"));
exports.participartingInsurers = {
    tokiomarine: [
        {
            percentage: 60,
            name: "Tokio Marine Kiln – Lloyd’s Underwriter Syndicates 510/KLN(80%) & 1880/TMK (20%) – Lloyd’s - Lloyd's One Lime Street, London EC3M7HA,UK"
        },
        { percentage: 15, name: "Convex Insurance UK Limited - LIRMA" },
        {
            name: "Antares – Lloyd’s Underwriter Syndicate 1274/AUL – Lloyd’s",
            percentage: 15
        },
        {
            name: "Axis - Lloyd's Underwriter Syndicate No. 1686/AXS - Lloyd's",
            percentage: 5
        },
        {
            name: "Aegis - Lloyd's Underwriter Syndicate No. 1225/AES - Lloyd's",
            percentage: 5
        }
    ],
    tokiomarineCan: [
        {
            percentage: 75,
            name: "Tokio Marine Kiln – Lloyd’s Underwriter Syndicates 510/KLN(80%) & 1880/TMK (20%) – Lloyd’s - Lloyd's One Lime Street, London EC3M7HA,UK"
        },
        { percentage: 15, name: "Lloyd’s Underwriter Syndicate 1274/AUL–Lloyd’s" },
        {
            name: " Lloyd's Underwriter Syndicate No.1686/AXS-Lloyd's",
            percentage: 5
        },
        {
            name: "Aegis - Lloyd's Underwriter Syndicate No.1225/AES-Lloyd's",
            percentage: 5
        }
    ]
};
const getProductBinderMock = (thamesType = "tokiomarine") => ({
    id: "argo",
    name: "Argo",
    usClassification: "Surplus Lines",
    uniqueMarketReference: "B0611CV220770",
    commissions: [
        {
            name: "Lochain Patrick",
            percentage: 2.5,
            type: "insuranceBroker"
        },
        {
            name: "Loadsure",
            percentage: 24.5,
            type: "loadsure"
        }
    ],
    participartingInsurers: exports.participartingInsurers[thamesType]
});
exports.getProductBinderMock = getProductBinderMock;
exports.binderMockV1 = {
    id: "argo",
    name: "Argo",
    usClassification: "Surplus Lines",
    uniqueMarketReference: "B0611CV220770",
    brokerName: "Lochain Patrick",
    brokerPercentage: 2.5,
    commissionPercentage: 24.5
};
const taxesMock = {
    id: "tax123",
    name: "Tax",
    country: "USA",
    state: "CO",
    taxes: [
        {
            id: 1,
            type: "stateTax",
            appliesTo: "premiumAndFees",
            value: 12300
        }
    ],
    description: ""
};
exports.emptyAddressMock = {
    address1: "",
    city: "",
    state: "",
    postal: "",
    country: ""
};
exports.addressCountryStateMock = {
    state: "CO",
    country: "USA"
};
exports.addressMock = Object.assign(Object.assign({}, exports.addressCountryStateMock), { address1: "15248 Yellowthroat Street", city: "Parker", postal: "80134" });
exports.insuranceLicenseMock = {
    active: true,
    type: "Excess Lines Licensee",
    licensee: "Ursus Insurance Services Inc.",
    number: "1800007365",
    expirationDate: "2023-10-31"
};
exports.partnerNoAddressMock = {
    id: "LS-DMO",
    name: "DEMO",
    partnerType: partner_1.ePartnerType.ASSURED,
    parentId: "@PORTAL",
    masterPolicyId: "LS-DEMO",
    payByInvoice: true,
    currency: currencies_1.eCurrency.USD,
    duplicateChecking: partner_1.eFreightIdDuplicationCheck.partner
};
exports.partnerNoAddressWithLicenseTaxesMock = Object.assign(Object.assign({}, exports.partnerNoAddressMock), { insuranceLicense: {
        country: "USA",
        state: "CO",
        owner: "ursus",
        licenseNumber: exports.insuranceLicenseMock.number
    }, taxes: taxesMock });
exports.partnerWithAddressMock = {
    id: "LS-DMO",
    name: "DEMO",
    address: exports.addressMock,
    partnerType: partner_1.ePartnerType.ASSURED,
    parentId: "@PORTAL",
    masterPolicyId: "LS-DEMO",
    payByInvoice: true,
    currency: currencies_1.eCurrency.USD,
    duplicateChecking: partner_1.eFreightIdDuplicationCheck.partner
};
exports.exFreightPartnerMock = {
    id: "LS-EXF",
    name: "EXFREIGHT",
    address: exports.addressMock,
    partnerType: partner_1.ePartnerType.ASSURED,
    parentId: "@PORTAL",
    masterPolicyId: "LS-EXF",
    payByInvoice: true,
    currency: currencies_1.eCurrency.USD,
    duplicateChecking: partner_1.eFreightIdDuplicationCheck.partner
};
const commodityExclusions = [
    "financial",
    "live",
    "luxury",
    "other",
    "tech",
    "temperature"
];
exports.restrictionsMock = {
    pickupCountries: ["USA-CNTL", "CAN"],
    deliveryCountries: ["USA-CNTL", "CAN"],
    equipmentTypes: [2, 3, 6, 1],
    truckloadTypes: ["FULL"],
    commodities: [
        2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
        24, 25, 26, 27, 1
    ]
};
exports.insuranceCoverageDescriptionMock = {
    id: "AR100",
    name: "All Risk 100",
    description: "This truckload product covers up to the full invoice value of general merchandise such as appliances, building supplies, chemicals, clothing, electronics, furniture, machinery, metals, minerals, paper products, textiles, vehicle and vehicle parts hauled by a truckload carrier. "
};
exports.insuranceCoverageCostsBaseMock = {
    limit: 100000,
    deductible: 500,
    premium: 39.99,
    currency: "USD"
};
exports.insuranceCoverageCostsV1Mock = Object.assign(Object.assign({}, exports.insuranceCoverageCostsBaseMock), { taxAmount: 0.24 });
exports.insuranceCoverageCostsMock = Object.assign(Object.assign({}, exports.insuranceCoverageCostsBaseMock), { serviceFee: 1.99, tax: 0.24 });
exports.insuranceCoverageCommissionMock = {
    commission: 0,
    commissionBreakdown: []
};
exports.serviceFeeBreakdownMock = [
    {
        partnerId: "LS-DMO",
        type: "FLAT_FEE",
        description: "Flat USD 10",
        currency: "USD",
        value: 10
    }
];
exports.taxBreakdownMock = [
    {
        type: "FLAT_TAX",
        name: "Suplus Lines Tax",
        currency: "USD",
        value: 1.25,
        description: "0.125% of Premium"
    }
];
exports.insuranceCoverageMockNoAddressLicenses = Object.assign(Object.assign(Object.assign(Object.assign({}, exports.insuranceCoverageDescriptionMock), { binder: exports.getProductBinderMock() }), exports.insuranceCoverageCostsMock), { commodityExclusions, restrictions: exports.restrictionsMock });
exports.insuranceCoverageMockWithAddressCountryStateAndLicenses = Object.assign(Object.assign({}, exports.insuranceCoverageMockNoAddressLicenses), { address: exports.addressCountryStateMock, insuranceLicenses: [
        Object.assign({}, exports.insuranceLicenseMock)
    ] });
exports.insuranceCoverageMockWithAddressCountryStateAndLicensesNoLicenseExp = Object.assign(Object.assign({}, exports.insuranceCoverageMockWithAddressCountryStateAndLicenses), { insuranceLicenses: exports.insuranceCoverageMockWithAddressCountryStateAndLicenses.insuranceLicenses.map((license) => (Object.assign(Object.assign({}, license), { expirationDate: "" }))) });
exports.insuranceCoverageMockWithAddressCountryStateAndLicensesBreakdowns = Object.assign(Object.assign({}, exports.insuranceCoverageMockWithAddressCountryStateAndLicenses), { serviceFeeBreakdown: exports.serviceFeeBreakdownMock, taxBreakdown: exports.taxBreakdownMock });
exports.insuranceCoverageMockWithAddressAndLicenses = Object.assign(Object.assign({}, exports.insuranceCoverageMockWithAddressCountryStateAndLicenses), { address: exports.addressMock });
exports.insuranceProductMock = Object.assign(Object.assign({}, exports.insuranceCoverageMockWithAddressAndLicenses), { termsAndConditionsLink: "https://portal.loadsure.net/some_terms_and_conditions", statementOfFact: "some statement of fact" });
exports.certificateV1insuranceProductMock = Object.assign(Object.assign(Object.assign(Object.assign({}, exports.insuranceCoverageDescriptionMock), { binder: exports.getProductBinderMock() }), exports.insuranceCoverageCostsV1Mock), { commodityExclusions, restrictions: exports.restrictionsMock });
exports.internationalProduct = {
    commodityExclusions,
    restrictions: exports.restrictionsMock,
    description: "This truckload product covers up to the full invoice value of general merchandise such as appliances, building supplies, chemicals, clothing, electronics, furniture, machinery, metals, minerals, paper products, textiles, vehicle and vehicle parts hauled by a truckload carrier. ",
    name: "All Risk International 100",
    id: "ARINT"
};
exports.userV1Mock = {
    id: "email@loadsure.net",
    firstName: "Damith",
    lastName: "Chandrasekara",
    email: "email@loadsure.net",
    phone: "+12563334"
};
exports.userV2Mock = {
    id: "email@loadsure.net",
    name: "Damith Chandrasekara",
    email: "email@loadsure.net",
    phone: "+12563334"
};
exports.temperatureRangeMock = {
    minimum: 30,
    maximum: 50,
    unit: "C"
};
const commodityData = {
    commodities: [2],
    otherCommodity: "something special"
};
const weightMock = {
    value: 408.23,
    unit: "kgs"
};
exports.cargoFromV1Mock = Object.assign(Object.assign({}, commodityData), { cargoValue: {
        value: 10000,
        currency: "USD"
    }, weight: weightMock, freightClasses: ["example freightClass"], nmfcNumber: "example nmfcNumber", notes: "example notes" });
exports.cargoMock = Object.assign(Object.assign({}, commodityData), { cargoValue: {
        value: 10000,
        currency: "USD"
    }, weight: weightMock, freightClasses: ["example freightClass"], fullDescriptionOfCargo: "fullD description of cargo test", hasPackagingDescriptionToCarrier: true, hsCodes: ["1006"], loadType: cargo_1.eTruckloadType.LTL, marksAndNumbers: "marks And Numbers", nmfcNumber: "example nmfcNumber", usedGoods: false, containerization: cargo_1.eContainerizationType.FULL_CONTAINER, temperatureRange: exports.temperatureRangeMock, truckload: cargo_1.eTruckloadType.LTL, storedPast30days: false, termsOfSale: "example terms of sale", notes: "example notes", packaging: [cargo_1.ePackagingType.CLEATED_PLYWOOD_BOXES], packagingDescription: "packaging description test", specificHandlingGuidelines: "specificHandlingGuidelines test", descriptionOfGoodsInsured: "description of goods insured test" });
exports.cargoClassInstanceMock = Object.assign(Object.assign({}, commodityData), { cargoValue: new utils_1.MonetaryValue("USD", 10000), weight: utils_1.Weight.fromObj(weightMock), freightClasses: ["example freightClass"], fullDescriptionOfCargo: "fullD description of cargo test", hasPackagingDescriptionToCarrier: true, hsCodes: ["1006"], loadType: cargo_1.eTruckloadType.LTL, marksAndNumbers: "marks And Numbers", nmfcNumber: "example nmfcNumber", usedGoods: false, containerization: cargo_1.eContainerizationType.FULL_CONTAINER, truckload: cargo_1.eTruckloadType.LTL, temperatureRange: utils_1.TemperatureRange.fromObj(exports.temperatureRangeMock), storedPast30days: false, termsOfSale: "example terms of sale", notes: "example notes", packaging: [cargo_1.ePackagingType.CLEATED_PLYWOOD_BOXES], packagingDescription: "packaging description test", specificHandlingGuidelines: "specificHandlingGuidelines test", descriptionOfGoodsInsured: "description of goods insured test" });
exports.businessMock = {
    name: "Some business",
    email: "business@loadsure.com",
    address: exports.addressMock,
    foundedInYear: 1999,
    businessType: international_1.businessTypes[4],
    descriptionOfOperations: "Computer's sell",
    annualShipments: 4587,
    cargoClaimsLast3Years: 40
};
const contactBaseMock = {
    id: "1",
    name: "Charles",
    email: "charles.macdonald@loadsure.net",
    phone: "+13857455",
    address: exports.addressMock
};
exports.contactMock = Object.assign(Object.assign({}, contactBaseMock), { ein: "321654897" });
exports.assuredMock = Object.assign({ type: "BUYER" }, exports.contactMock);
exports.shipmentContactMock = {
    id: "2",
    name: "John Doe",
    email: "johndoe@loadsure.net",
    phone: "+178459653",
    address: exports.addressMock
};
exports.carrierMock = Object.assign({ mcMxFfNumber: "531553144" }, contactBaseMock);
const equipmentTypeData = {
    equipmentType: 1,
    otherEquipmentType: "example other equipment type"
};
exports.roadCarrier = Object.assign(Object.assign(Object.assign({ mode: "ROAD" }, contactBaseMock), { carrierId: {
        type: "MCMXFF",
        value: "531553144"
    } }), equipmentTypeData);
exports.railCarrier = Object.assign(Object.assign({ mode: "RAIL" }, contactBaseMock), { railwayName: "Example Railway", trainNumber: "12312412", carrierId: {
        type: "trailNumber",
        value: "12312412"
    } });
exports.marineCarrierOld = Object.assign(Object.assign({ mode: "MARINE" }, contactBaseMock), { imo: "example imo", withinLimitsOfICC: false, stowageDetails: "UNDER_DECK", registrationCountry: "USA", mmsi: "example mmsi", vesselClass: "example vesselClass", status: "example status", pAndI: "example pAndI", yearOfService: 3, detentions: 0, previousIncidents: 1 });
exports.marineCarrier = Object.assign(Object.assign({ mode: "MARINE" }, contactBaseMock), { carrierId: {
        type: "IMO",
        value: "12312412412"
    }, withinLimitsOfICC: false, stowageDetails: "UNDER_DECK", registrationCountry: "USA", mmsi: "example mmsi", vesselClass: "example vesselClass", status: "example status", pAndI: "example pAndI", yearOfService: 3, detentions: 0, previousIncidents: 1 });
exports.airCarrier = Object.assign(Object.assign({ mode: "AIR" }, contactBaseMock), { airlineName: "Example Airline", flightNumber: "12312412" });
const dates = {
    pickupDate: new Date("2020-12-28").toISOString(),
    deliveryDate: new Date("2021-01-18").toISOString()
};
exports.pickupStopMock = {
    stopType: "PICKUP",
    date: dates.pickupDate,
    address: {
        address1: "12340 Boggy Creek Rd",
        address2: null,
        city: "Orlando",
        state: "FL",
        postal: "32824",
        country: "USA"
    }
};
exports.additionalStopMock = {
    stopType: "ADDITIONAL",
    address: {
        address1: "12342 Somewhere Rd",
        address2: null,
        city: "Denver",
        state: "ON",
        postal: "80241",
        country: "CAN"
    }
};
exports.deliveryStopMock = {
    stopType: "DELIVERY",
    date: dates.deliveryDate,
    address: {
        address1: "345 California St",
        address2: null,
        city: "San Francisco",
        state: "CA",
        postal: "94104",
        country: "USA"
    }
};
exports.portOfLoadingStopMock = {
    stopType: "PORT_OF_LOADING",
    date: dates.pickupDate,
    name: "Port of New York",
    country: "USA"
};
exports.portOfDischargeStopMock = {
    stopType: "PORT_OF_DISCHARGE",
    date: dates.deliveryDate,
    name: "Port of Houston",
    country: "USA"
};
const stopsMock = [exports.pickupStopMock, exports.additionalStopMock, exports.deliveryStopMock];
exports.visibilityMock = {
    telematicsType: "VEHICLE_LEVEL",
    telematicsProvider: "example telematicsProvider"
};
exports.paymentMethodMock = {
    type: payments_1.ePaymentMethodType.BILL_TO_INVOICE
};
exports.paymentMock = {
    type: payments_1.ePaymentType.INVOICE
};
exports.CCPaymentMock = {
    processor: "PAYHAWK",
    transactionId: "7483812028",
    type: "CREDIT_CARD"
};
exports.shipmentV1Mock = Object.assign(Object.assign({ freightIdOrBol: "F-9407200", commodityId: 2, commodity: "something special", equipmentTypeId: 1, equipmentType: "example other equipment type" }, dates), { shipmentValue: 10000, weight: weightMock.value, weightUnit: weightMock.unit, freightClass: "example freightClass", nmfcNumber: "example nmfcNumber", id: "undefined", loadType: "", notes: "example notes", cargo: "example cargo" });
exports.shipmentV2FromV1Mock = Object.assign(Object.assign({ freightId: "F-9407200" }, dates), { cargo: exports.cargoFromV1Mock, carriers: [exports.roadCarrier], stops: stopsMock });
exports.shipmentV2Mock = Object.assign(Object.assign({ freightId: "F-9407200" }, dates), { shipper: exports.businessMock, cargo: exports.cargoMock, carriers: [exports.roadCarrier], stops: stopsMock, visibility: exports.visibilityMock });
exports.insuranceLoadV1Mock = {
    user: exports.userV1Mock,
    shipment: exports.shipmentV1Mock,
    carrier: exports.carrierMock,
    certificateHolder: exports.assuredMock,
    stops: stopsMock
};
const certificateNumber = "89723442892439";
exports.InsuranceCertificatePurchaseResponseMock = Object.assign({ certificateNumber, productId: exports.insuranceCoverageDescriptionMock.id, productName: exports.insuranceCoverageDescriptionMock.name }, exports.insuranceCoverageCostsMock);
exports.insurancePurchaseV1Mock = {
    user: exports.userV1Mock,
    shipment: exports.shipmentV1Mock,
    certificateHolder: exports.assuredMock,
    stops: stopsMock,
    insuranceProduct: exports.certificateV1insuranceProductMock,
    emailCertificateHolder: false
};
const authorizedUsersMock = [exports.userV2Mock.email, exports.contactMock.email];
exports.InsuranceCertificatePurchaseRequestMock = {
    user: exports.userV2Mock,
    assured: exports.assuredMock,
    coverage: exports.insuranceCoverageMockWithAddressAndLicenses,
    shipment: exports.shipmentV2Mock,
    paymentMethod: exports.paymentMethodMock
};
const coverholderMock = {
    name: "coverHolder"
};
exports.certificateV1Mock = {
    partner: exports.partnerNoAddressMock,
    binder: exports.binderMockV1,
    coverholder: coverholderMock,
    certificateNumber,
    purchasedDate: "2020-05-10",
    user: exports.userV1Mock,
    insuranceProduct: exports.certificateV1insuranceProductMock,
    certificateHolder: exports.assuredMock,
    shipment: exports.shipmentV1Mock,
    stops: stopsMock,
    authorizedUsers: authorizedUsersMock,
    carrier: exports.carrierMock,
    version: 5
};
exports.certificateV2Mock = {
    version: 2,
    partner: exports.partnerNoAddressWithLicenseTaxesMock,
    partnerIds: ["@PORTAL", exports.partnerNoAddressWithLicenseTaxesMock.id],
    certificateNumber,
    purchasedDate: "2020-05-10",
    user: exports.userV2Mock,
    coverage: exports.insuranceCoverageMockNoAddressLicenses,
    assured: exports.assuredMock,
    shipment: exports.shipmentV2Mock,
    payment: exports.paymentMock,
    authorizedUsers: authorizedUsersMock
};
exports.certificateV3Mock = Object.assign(Object.assign({}, exports.certificateV2Mock), { version: 3 });
exports.certificateV4Mock = Object.assign(Object.assign({}, exports.certificateV3Mock), { version: 4 });
exports.certificateV5Mock = Object.assign(Object.assign({}, exports.certificateV4Mock), { version: 5, partner: exports.partnerWithAddressMock, coverage: exports.insuranceCoverageMockWithAddressAndLicenses });
exports.certificateCurrentMock = exports.certificateV5Mock;
exports.certificateCurrentFromV1 = Object.assign(Object.assign({}, exports.certificateCurrentMock), { partner: exports.partnerNoAddressMock, coverage: Object.assign(Object.assign({}, exports.insuranceCoverageMockNoAddressLicenses), { serviceFee: 0 }), shipment: exports.shipmentV2FromV1Mock });
const certificateCurrentFromV2to4Mock = (version) => (Object.assign(Object.assign({}, exports.certificateCurrentMock), { partner: exports.partnerNoAddressMock, coverage: exports.insuranceCoverageMockWithAddressCountryStateAndLicensesNoLicenseExp, version }));
exports.certificateCurrentFromV2to4Mock = certificateCurrentFromV2to4Mock;
exports.certificateCancelChangeMock = {
    author: "johndoe@example.com",
    type: certificateChange_1.eCertificateChangeType.CANCELLED,
    date: new Date("2022-09-11").toISOString(),
    changes: [
        {
            fieldMap: "status",
            from: _1.eInsuranceCertificateStatus.active,
            to: _1.eInsuranceCertificateStatus.cancelled
        }
    ]
};
exports.certificateCancelChangeEmptyMock = {
    author: "",
    type: "updated",
    date: "",
    changes: []
};
exports.certificateChangeDetailsEmptyMock = {
    fieldMap: "",
    from: "",
    to: ""
};
exports.certificateChangeHistoryMock = {
    author: "johndoe@example.com",
    type: certificateChange_1.eCertificateChangeType.RESTORED,
    date: new Date().toISOString(),
    changes: [
        {
            fieldMap: "status",
            from: _1.eInsuranceCertificateStatus.cancelled,
            to: _1.eInsuranceCertificateStatus.active
        }
    ]
};
exports.pathAttachmentFile = {
    name: "pat_mock_file.json",
    size: 129000,
    path: "./contries/countries.json"
};
exports.blobAttachmentFile = {
    name: "pat_mock_file.pdf",
    size: 129000,
    content: Buffer.from("blob file test....................")
};
exports.emptyPartnerInfoMock = {
    id: "",
    name: "",
    description: "",
    payByInvoice: false,
    address: address_1.default.empty(),
    currency: "",
    partnerType: ""
};
exports.partnerInfoMock = {
    id: "id",
    name: "name",
    description: "description",
    parentId: "parent id",
    partnerType: "ASSURED",
    payByInvoice: true,
    address: address_1.default.fromObj(exports.addressMock),
    currency: "USD",
    duplicateChecking: partner_1.eFreightIdDuplicationCheck.partner,
    insuranceLicenseId: "",
    isEnabled: true,
    isSandbox: false,
    primaryContact: contact_1.default.fromObj(Object.assign(Object.assign({}, exports.userV2Mock), { partnerId: "id" })),
    brokerContact: contact_1.default.fromObj(Object.assign(Object.assign({}, exports.userV2Mock), { partnerId: "id" })),
    underwriterContact: undefined,
    zone: undefined,
    kyc: undefined,
    lastTransactionDates: null,
    primaryBusinessType: partner_1.ePrimaryBusinessType.CARRIER,
    dunsId: "15-048-3782",
    isEmpty: function () {
        return (!this.id &&
            !this.name &&
            !this.description &&
            !this.payByInvoice &&
            !this.address &&
            !this.currency &&
            !this.partnerType);
    }
};
exports.partnerBillingMock = {
    name: "name",
    email: "email@loadsure.net",
    differentBillingAddress: false,
    invoiceFrequecy: "Monthly",
    periodEnding: "LastDay",
    commissionPercentage: 0,
    chargeBrokerServiceFee: false,
    ccEmail: "email2@loadsure.net",
    address: address_1.default.fromObj(exports.addressMock)
};
const user = user_1.default.fromObj({
    email: "johndoe@example.com",
    name: "john"
});
exports.mockBroker = broker_1.default.fromObj({
    id: "",
    name: "John Doe",
    email: "johndoe@example.com",
    office: "RESELLER1",
    partnerId: "RESELLER1",
    address: exports.addressMock,
    phone: ""
});
exports.policyData = {
    policyNumber: "ABC123",
    effectiveDate: "2023-01-01",
    hasPreviousPolicy: false,
    type: policy_1.ePolicyType.OCEAN_CARGO,
    user,
    partnerId: "RESELLER1",
    broker: exports.mockBroker,
    assured: assured_1.default.fromObj(Object.assign({}, exports.contactMock)),
    channel: _1.eInsuranceCertificatePurchaseChannel.PORTAL,
    createdDate: undefined,
    exposures: undefined,
    losses: undefined,
    coverage: undefined,
    warehouse: undefined,
    steps: undefined,
    callback: undefined
};
exports.mockDocument = {
    documentPath: "path",
    documentName: "name",
    bucketName: "bucket",
    size: 1000,
    fileType: "path",
    success: true
};
exports.exposuresMock = {
    coverageForDomesticShipments: true,
    primaryDomesticShipment: 20,
    contingentDomesticShipment: 20,
    primaryInternationalShipment: 20,
    contingentInternationalShipment: 20,
    totalInternationalShipment: 20,
    conveyanceSizeAndLimits: {
        vesselOrAircraft: {},
        oneShipment: {
            averageValue: 100,
            maximumValue: 150,
            desiredLimit: 120
        },
        truckOrRailcar: {},
        packageMailOrParcelPost: {}
    },
    primaryCommodity: "primary commodity",
    secondaryCommodities: ["secondary commodity 1", "secondary commodity 2"],
    isTemperatureSensitive: true,
    temperatureDesiredCoverage: "24 hour breakdown",
    allGoodsBeContainerized: true,
    detailedPackagingDescription: "",
    valuation: "CIF +10%",
    numberOfAnnualSales: {
        currency: "USD",
        value: 1000
    },
    goodsInsuredDescription: "goods insured description...",
    annualShipmentVolume: 10000,
    targetPremium: 900,
    currentDeductible: 2500,
    maximumDesiredCoverageLimit: 10000,
    coverageForExhibition: true,
    salespersonsSamplesCoverage: 25000,
    exhibitionCoverage: 100000
};
exports.lossesMock = {
    yearsOfClaimHistory: 2,
    claimsHistory: [
        {
            year: 2022,
            totalGrossLosses: 3000,
            numberOfLosses: 2
        },
        {
            year: 2021,
            totalGrossLosses: 2000,
            numberOfLosses: 1
        }
    ],
    lossRecordAvailable: true,
    lossRecordDocuments: [exports.mockDocument],
    confirmNoKnowLossHistory: {
        confirmed: true,
        confirmedBy: "cesar.giraldo@loadsure.net"
    },
    claimDescription: "this is the claim description..."
};
exports.locationMock = {
    yearLastRoofUpdate: "2000",
    thirdPartyLocation: true,
    maximunInventoryValue: "30",
    constructionType: "Joisted Masonry (Construction Code 2)",
    address: {
        country: "United States",
        state: "NY",
        city: "New York",
        postal: "10001",
        address1: "230 5th Avenue"
    },
    buildingNo: "1",
    occupancy: "Heavy Manufacturing Facility",
    commodityState: "Raw Materials",
    locationNo: 1,
    yearBuilt: "1900",
    desiredLimit: 10,
    currentDeductible: 10,
    desiredDeductible: 10,
    desiredNATCATPerilsSublimit: 10,
    willGoodsBeStoredInContainers: true,
    securityProtectionsInPlace: [],
    locationLossesLastFiveYears: true,
    claimsHistory: [],
    confirmNoKnowLossHistory: true,
    lossRecordAvailable: true,
    lossRecordDocuments: true,
    claimDescription: "text"
};
exports.warehouseMock = {
    coverageForGoodsInStorage: true,
    locations: [exports.locationMock],
    storageLossesLastFiveYears: true
};
exports.claimDomesticMock = {
    partner: exports.partnerWithAddressMock,
    certificateNumber: "1635FE21-B860-4E09-8CA6-AFAFDFA6FE12",
    purchasedDate: "2023-05-05T17:16:53-05:00",
    user: exports.userV2Mock,
    coverage: exports.insuranceCoverageMockWithAddressCountryStateAndLicenses,
    assured: exports.assuredMock,
    shipment: Object.assign({ pickupStop: exports.pickupStopMock, deliveryStop: exports.deliveryStopMock }, exports.shipmentV2Mock),
    payment: { type: "INVOICE" },
    partnerIds: ["@PORTAL", "LS-DEMO-V2"],
    authorizedUsers: [
        "pablo.quiceno@loadsure.net",
        "jairo.martinez@loadsure.net"
    ],
    channel: "portal-website",
    sandbox: true,
    version: 4,
    step: 4,
    details: {
        lossDate: "2023-05-08",
        description: "dsfsdgsdg",
        causeOfLoss: "concealedDamage",
        additionalCharges: 120,
        deliveryNoteComment: "itemsReceivedDamaged",
        invoiceValue: 20000,
        lossLocation: "Miami",
        lossCarriers: [
            {
                id: "YWxnby1tYXJpbmU=",
                name: "Algo",
                email: "email@algo.com",
                mode: "MARINE",
                carrierId: { type: "IMO", value: "435634" },
                withinLimitsOfICC: true,
                registrationCountry: "USA",
                yearOfService: "1901",
                detentions: "10",
                previousIncidents: "1"
            }
        ],
        requestedClaimValue: 15000,
        lossOccurredCarrier: "primary"
    },
    documents: {
        commercialInvoice: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        consignmentNote: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        deliveryReceipts: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        inlandBillOfLading: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        photos: [{ size: 24948, name: "visual-studio-code-2019.png" }],
        packingList: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        seaWaybill: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        copyLetterToCarrier: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        vesselsOutturnReport: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        containerDamageReport: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        interchangeReceipt: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        mastersStatementOfFacts: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        preshipmentSurveys: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        condemnationCertificates: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        certificateOrOrigin: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        }
    },
    contact: exports.contactMock,
    completed: { details: true, documents: true, contact: true },
    claimStatus: "submitted",
    sendEmailTo: ["pablo.quiceno@loadsure.net"],
    applicableFreightCostsAndCharges: 90,
    applicableAllowanceForAdditionalCosts: 1512.375,
    relatedInsuranceCosts: 33.75,
    totalClaimAmount: 14136.125,
    totalLoss: 16636.125
};
exports.claimInternationalMock = {
    partner: exports.partnerWithAddressMock,
    certificateNumber: "AF8443B8-4D55-4FC0-BDFA-CA759C8EBDFD",
    purchasedDate: "2023-05-08T07:42:34-05:00",
    user: exports.userV2Mock,
    coverage: exports.insuranceCoverageMockWithAddressCountryStateAndLicenses,
    assured: exports.assuredMock,
    shipment: Object.assign({ pickupStop: exports.pickupStopMock, deliveryStop: exports.deliveryStopMock }, exports.shipmentV2Mock),
    payment: { type: "INVOICE" },
    partnerIds: ["@PORTAL", "LS-DEMO-V2"],
    authorizedUsers: ["pablo.quiceno@loadsure.net", "muha@mail.com"],
    channel: "portal-website",
    sandbox: true,
    version: 4,
    step: 4,
    details: {
        lossDate: "2023-05-08",
        description: "wfwefasdf",
        causeOfLoss: "concealedDamage",
        additionalCharges: 200,
        deliveryNoteComment: "itemsReceivedDamaged",
        invoiceValue: 18000,
        lossLocation: "Miami",
        lossCarriers: [
            {
                id: "YWxnby1tYXJpbmU=",
                name: "Algo",
                email: "email@algo.com",
                mode: "MARINE",
                carrierId: {
                    type: "IMO",
                    value: "435634"
                },
                withinLimitsOfICC: true,
                registrationCountry: "USA",
                yearOfService: "1901",
                detentions: "10",
                previousIncidents: "1"
            }
        ],
        requestedClaimValue: 15000,
        lossOccurredCarrier: "primary"
    },
    documents: {
        commercialInvoice: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        consignmentNote: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        deliveryReceipts: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        inlandBillOfLading: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        photos: [
            {
                size: 24948,
                name: "visual-studio-code-2019.png"
            }
        ],
        packingList: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        seaWaybill: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        copyLetterToCarrier: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        vesselsOutturnReport: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        containerDamageReport: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        interchangeReceipt: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        mastersStatementOfFacts: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        preshipmentSurveys: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        condemnationCertificates: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        },
        certificateOrOrigin: {
            size: 267276,
            name: "Loadsure - Insurance Certificate - D8C2623D-DD44-4C0B-A046-DDF70A276885.pdf"
        }
    },
    contact: exports.contactMock,
    completed: {
        details: true,
        documents: true,
        contact: true
    },
    claimStatus: "draft",
    sendEmailTo: ["pablo.quiceno@loadsure.net"],
    applicableFreightCostsAndCharges: 166.66666666666669,
    applicableAllowanceForAdditionalCosts: 1520.4166666666667,
    relatedInsuranceCosts: 37.5,
    totalClaimAmount: 14224.583333333332,
    totalLoss: 16724.583333333332
};
exports.AnnualCargoCommodityMock = {
    primary: [
        {
            id: 1,
            name: "Primary"
        },
        {
            id: 2,
            name: "Primary Alternative"
        },
        {
            id: 3,
            name: "Primary with all secondary",
            allSecondary: true
        }
    ],
    secondary: [
        {
            name: "Secondary",
            belongsTo: [1]
        },
        {
            name: "Secondary Alternative",
            belongsTo: [2]
        }
    ]
};
exports.licenseChangeOldEndorsementMock = {
    effectiveDate: "2021-11-02",
    type: "LICENSE_CHANGE",
    insuranceLicense: {
        old: {
            owner: "avalon",
            ownerName: "Avalon Risk Management",
            licenseNumber: "0G98514"
        },
        new: {
            owner: "ursus",
            ownerName: "Ursus Insurance Services Inc.",
            licenseNumber: "6005340"
        }
    }
};
exports.licenseChangeEndorsementMock = {
    effectiveDate: "2021-11-02",
    type: _1.eMasterPolicyEndorsementType.LICENSE_CHANGE,
    change: {
        old: {
            owner: "avalon",
            ownerName: "Avalon Risk Management",
            licenseNumber: "0G98514"
        },
        new: {
            owner: "ursus",
            ownerName: "Ursus Insurance Services Inc.",
            licenseNumber: "6005340"
        }
    },
    insuranceLicense: undefined
};
exports.partnerNameEndorsementMock = {
    effectiveDate: "2023-05-02",
    type: _1.eMasterPolicyEndorsementType.PARTNER_NAME_CHANGE,
    change: {
        old: "Daniela NonParis Swiss Venue 1",
        new: "Daniela NonParis Swiss Venue 2"
    }
};
exports.partnerAddressChangeEndorsementMock = {
    effectiveDate: "2023-07-02",
    type: _1.eMasterPolicyEndorsementType.PARTNER_ADDRESS_CHANGE,
    change: {
        old: {
            address1: "345 Sunlight",
            city: "Chicago",
            state: "IL",
            postal: "43343",
            country: "USA"
        },
        new: {
            address1: "808 Collins Av",
            city: "Miami",
            state: "FL",
            postal: "56743",
            country: "USA"
        }
    }
};
exports.participatingInsurersEndorsementMock = {
    effectiveDate: "2023-05-02",
    type: _1.eMasterPolicyEndorsementType.PARTICIPATING_INSURERS_CHANGE,
    change: {
        old: [
            {
                percentage: 50,
                name: "name 1"
            },
            {
                percentage: 50,
                name: "name 2"
            }
        ],
        new: [
            {
                percentage: 30,
                name: "name 1"
            },
            {
                percentage: 30,
                name: "name 2"
            },
            {
                percentage: 40,
                name: "name 3"
            }
        ]
    }
};
const getMasterPolicyMock = (thamesType = "tokiomarine") => ({
    partner: {
        id: "ASSURED_ID",
        name: "Assured Partner Test",
        address: {
            address1: "345 Sunlight",
            city: "Chicago",
            state: "IL",
            postal: "43343",
            country: "USA"
        }
    },
    insuranceLicense: {
        type: "Excess Lines Licensee",
        licensee: "Ursus Insurance Services Inc.",
        licenseNumber: "ABC12345",
        expirationDate: "2025-06-30T00:00:00.000Z"
    },
    uniqueMarketReference: "ABC12345",
    policyType: "Master-Policy",
    period: {
        startDate: "2022-10-17",
        endDate: "2023-10-17"
    },
    limit: {
        currency: "USD",
        value: 2000000
    },
    endorsements: [
        exports.licenseChangeEndorsementMock,
        exports.partnerNameEndorsementMock,
        exports.partnerAddressChangeEndorsementMock,
        exports.participatingInsurersEndorsementMock
    ],
    binder: exports.getProductBinderMock(thamesType)
});
exports.getMasterPolicyMock = getMasterPolicyMock;
const getInvoiceMock = (version) => ({
    version,
    billingPeriod: {
        startDate: "2024-06-01",
        endDate: "2024-06-30"
    },
    commission: 0,
    createdDate: new Date("2024-07-05").toISOString(),
    currency: "USD",
    date: "2024-07-01",
    grossPremium: 103.56,
    invoiceNumber: "ABC-PARTNER.2024M06",
    lastModifiedDate: new Date("2024-07-05").toISOString(),
    lineItems: [
        {
            certificateNumber: "7BB04D98-2C96-468F-8BA4-808C50CC21C2",
            date: "2024-06-25",
            paymentType: "INVOICE",
            premium: 93.56,
            productName: "All Risk Domestic General Merchandise",
            serviceFee: 0,
            tax: 10,
            total: 103.56
        }
    ],
    netAmountDue: 103.56,
    serviceFee: 0,
    tax: 10,
    totalCreditCard: 0,
    partner: {
        id: "ABC-PARTNER",
        commissionPercentage: 0,
        masterPolicyId: "ABC-PARTNER",
        name: "Assured Partner Test",
        serviceFeeLabel: "Service Fee",
        billingContact: {
            id: "",
            name: "John Doe",
            email: "johndoe@example.com",
            address: {
                address1: "345 Sunlight",
                city: "Chicago",
                state: "IL",
                postal: "43343",
                country: "USA"
            }
        }
    }
});
exports.getInvoiceMock = getInvoiceMock;
exports.existingInvoiceAdjustmentMock = {
    adjustmentId: "2BEE17A5",
    invoiceId: "1675VE21-G860-4E09-8AA6",
    certificateNumber: "1635FE21-B860-4E09-8CA6-AFAFDFA6FE12",
    adjustmentType: invoiceAdjustment_1.eAdjustmentType.CREDIT,
    adjustmentAmount: 567,
    adjustmentConcept: invoiceAdjustment_1.eAdjustmentConcept.CANCELLED_CERTIFICATE,
    createdDate: new Date("2025-02-04T15:38:54-05:00"),
    status: invoiceAdjustment_1.eAdjustmentStatus.APPROVED,
    approvedOrRejectedDate: new Date("2025-02-03T15:38:54-05:00"),
    approvedOrRejectedBy: "jhondoe@loadsure.net",
    additionalInformation: "lorem ipsum dolor sit amet"
};
exports.newInvoiceAdjustmentMock = {
    invoiceId: "1675VE21-G860-4E09-8AA6",
    certificateNumber: "1635FE21-B860-4E09-8CA6-AFAFDFA6FE12",
    adjustmentType: invoiceAdjustment_1.eAdjustmentType.CREDIT,
    adjustmentAmount: 567,
    adjustmentConcept: invoiceAdjustment_1.eAdjustmentConcept.CANCELLED_CERTIFICATE,
    status: invoiceAdjustment_1.eAdjustmentStatus.APPROVED,
    approvedOrRejectedDate: new Date("2025-02-03T15:38:54-05:00"),
    approvedOrRejectedBy: "jhondoe@loadsure.net",
    additionalInformation: "lorem ipsum dolor sit amet"
};
exports.invoiceAdjustmentPendingMock = {
    invoiceId: "1675VE21-G860-4E09-8AA6",
    certificateNumber: "1635FE21-B860-4E09-8CA6-AFAFDFA6FE12",
    adjustmentType: invoiceAdjustment_1.eAdjustmentType.CREDIT,
    adjustmentAmount: 567,
    adjustmentConcept: invoiceAdjustment_1.eAdjustmentConcept.CANCELLED_CERTIFICATE,
    status: invoiceAdjustment_1.eAdjustmentStatus.PENDING_REVIEW,
    additionalInformation: "lorem ipsum dolor sit amet"
};
//# sourceMappingURL=mocks.js.map